import { combineReducers } from 'redux';
import { INITIAL_STATE, DOKTER_PROVINSI_LOADING, DOKTER_PROVINSI_ERROR, DOKTER_PROVINSI_SUCCESS, DOKTER_KOTA_LOADING, DOKTER_KOTA_SUCCESS, DOKTER_KOTA_ERROR, DOKTER_GET_LOADING, DOKTER_GET_SUCCESS, DOKTER_GET_ERROR, DOKTER_SAVE_LOADING, DOKTER_SAVE_SUCCESS, DOKTER_SAVE_ERROR, DOKTER_UPDATE_LOADING, DOKTER_UPDATE_SUCCESS, DOKTER_UPDATE_ERROR, DOKTER_DELETE_LOADING, DOKTER_DELETE_SUCCESS, DOKTER_DELETE_ERROR, DOKTER_LIST_LOADING, DOKTER_LIST_SUCCESS, DOKTER_LIST_ERROR } from './actions';

const dokterProvinsi = (state = INITIAL_STATE, actions) => {
    switch (actions.type) {
        case DOKTER_PROVINSI_LOADING:
            return {
                ...state,
                status: 'loading',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case DOKTER_PROVINSI_SUCCESS:
            return {
                ...state,
                status: 'success',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case DOKTER_PROVINSI_ERROR:
            return {
                ...state,
                status: 'error',
                loading: actions.loading,
                data: actions.data,
                error: actions.error

            }
        default:
            return INITIAL_STATE
    }
}

const dokterKota = (state = INITIAL_STATE, actions) => {
    switch (actions.type) {
        case DOKTER_KOTA_LOADING:
            return {
                ...state,
                status: 'loading',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case DOKTER_KOTA_SUCCESS:
            return {
                ...state,
                status: 'success',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case DOKTER_KOTA_ERROR:
            return {
                ...state,
                status: 'error',
                loading: actions.loading,
                data: actions.data,
                error: actions.error

            }
        default:
            return INITIAL_STATE
    }
}

const dokterGet = (state = INITIAL_STATE, actions) => {
    switch (actions.type) {
        case DOKTER_GET_LOADING:
            return {
                ...state,
                status: 'loading',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case DOKTER_GET_SUCCESS:
            return {
                ...state,
                status: 'success',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case DOKTER_GET_ERROR:
            return {
                ...state,
                status: 'error',
                loading: actions.loading,
                data: actions.data,
                error: actions.error

            }
        default:
            return INITIAL_STATE
    }
}

const dokterSave = (state = INITIAL_STATE, actions) => {
    switch (actions.type) {
        case DOKTER_SAVE_LOADING:
            return {
                ...state,
                status: 'loading',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case DOKTER_SAVE_SUCCESS:
            return {
                ...state,
                status: 'success',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case DOKTER_SAVE_ERROR:
            return {
                ...state,
                status: 'error',
                loading: actions.loading,
                data: actions.data,
                error: actions.error

            }
        default:
            return INITIAL_STATE
    }
}

const dokterUpdate = (state = INITIAL_STATE, actions) => {
    switch (actions.type) {
        case DOKTER_UPDATE_LOADING:
            return {
                ...state,
                status: 'loading',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case DOKTER_UPDATE_SUCCESS:
            return {
                ...state,
                status: 'success',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case DOKTER_UPDATE_ERROR:
            return {
                ...state,
                status: 'error',
                loading: actions.loading,
                data: actions.data,
                error: actions.error

            }
        default:
            return INITIAL_STATE
    }
}

const dokterDelete = (state = INITIAL_STATE, actions) => {
    switch (actions.type) {
        case DOKTER_DELETE_LOADING:
            return {
                ...state,
                status: 'loading',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case DOKTER_DELETE_SUCCESS:
            return {
                ...state,
                status: 'success',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case DOKTER_DELETE_ERROR:
            return {
                ...state,
                status: 'error',
                loading: actions.loading,
                data: actions.data,
                error: actions.error

            }
        default:
            return INITIAL_STATE
    }
}

const dokterList = (state = INITIAL_STATE, actions) => {
    switch (actions.type) {
        case DOKTER_LIST_LOADING:
            return {
                ...state,
                status: 'loading',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case DOKTER_LIST_SUCCESS:
            return {
                ...state,
                status: 'success',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case DOKTER_LIST_ERROR:
            return {
                ...state,
                status: 'error',
                loading: actions.loading,
                data: actions.data,
                error: actions.error

            }
        default:
            return INITIAL_STATE
    }
}


const dokterReducer = combineReducers({
    provinsi: dokterProvinsi,
    kota: dokterKota,
    data: dokterGet,
    save: dokterSave,
    update: dokterUpdate,
    delete: dokterDelete,
    list: dokterList
})

export default dokterReducer;